import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 *
  USE IN TEMPALTE WITH ngModel
 *
  <app-ui-radio-group [label]="''" [tooltipText]="'text'" [horizonalPosition]="true">
    <app-ui-radio-button [value]="1" [(ngModel)]="radioButtonExample">Option 1</app-ui-radio-button>
    <app-ui-radio-button [value]="2" [(ngModel)]="radioButtonExample">Option 2</app-ui-radio-button>
    <app-ui-radio-button [value]="3" [(ngModel)]="radioButtonExample">Option 3</app-ui-radio-button>
  </app-ui-radio-group>
 *
 *
 *
  USE WITHIN REACTIVE FORM
 *
  <form [formGroup]="radioGroupForm">
    <app-ui-radio-group [label]="'text'" [hasError]="radioGroupForm.invalid">
      <app-ui-radio-button [value]="1" formControlName="radio">Option 1</app-ui-radio-button>
      <app-ui-radio-button [value]="2" formControlName="radio">Option 2</app-ui-radio-button>
      <app-ui-radio-button [value]="3" formControlName="radio">Option 3</app-ui-radio-button>
      <app-ui-radio-button [value]="4" formControlName="radio">Option 4</app-ui-radio-button>
    </app-ui-radio-group>
  </form>
 *
 */

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-ui-radio-group',
  styleUrls: ['./ui-radio-group.component.scss'],
  templateUrl: './ui-radio-group.component.html',
  standalone: false
})
export class UIRadioGroupComponent {
  @Input() horizonalPosition: boolean; // Only if those items can fit in one line, eg 3
  @Input() label: string;
  @Input() tooltipText: string;
  @Input() hasError: boolean;
}
